<template>
    <button :type="type" class="btn" :class="[color, size]">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ButtonExecCreate',
    props: {
        text: {
            type: String,
            default: '登録',
        },
        icon: {
            type: String,
            default: 'bi-plus-lg',
        },
        type: {
            type: String,
            default: 'submit',
        },
        color: {
            type: String,
            default: 'btn-primary'
        },
        size: {
            type: String,
            default: '',
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
